import { AppFile } from "./app-file";
import { SafeResourceUrl } from "@angular/platform-browser";

export class VenueLayout {
  id: number;
  name: string;
  description: string;
  fileName: string;
  fileDescription: string;
  filePath: SafeResourceUrl;
  appFileId: number;
  appFile: AppFile;
  venueId: number;
  
}



// WEBPACK FOOTER //
// ./src/app/core/models/venue-layout.ts